var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { Box, makeStyles } from "@material-ui/core";
export const FTLUnderlinedBox = React.forwardRef((_a, ref) => {
    var { className = "" } = _a, otherProps = __rest(_a, ["className"]);
    const classes = useStyles();
    return (React.createElement("div", { className: className + " " + classes.root, ref: ref },
        React.createElement(Box, Object.assign({}, otherProps))));
});
const useStyles = makeStyles({
    root: {
        padding: "24px 0 16px 0",
        "&:not(:last-of-type)": {
            boxShadow: "inset 0px -1px 0px #EBEDF0",
        },
    },
});
//# sourceMappingURL=index.js.map